'use client';
import { Field, Form } from '@/components/hook-form';
import { useAdminAuth } from '@/contexts/admin-auth-context';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

// Validation schema
const LoginSchema = Yup.object().shape({
  name: Yup.string().required('Username is required'),
  password: Yup.string().required('Password is required'),
});

type FormValues = {
  name: string;
  password: string;
};

export default function AdminLoginPage() {
  const { login, isAuthenticated } = useAdminAuth();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const router = useRouter();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      router.push('/workflow-config');
    }
  }, [isAuthenticated, router]);

  const methods = useForm<FormValues>({
    resolver: yupResolver(LoginSchema),
    defaultValues: {
      name: '',
      password: '',
    },
  });

  const handleSubmit = methods.handleSubmit(async (data: FormValues) => {
    setSubmitting(true);
    setError('');

    try {
      console.log('Attempting login with:', data);
      const success = await login(data.name, data.password);
      if (success) {
        router.push('/workflow-config');
      } else {
        setError('Invalid username or password');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('An error occurred during login');
    } finally {
      setSubmitting(false);
    }
  });

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          py: 12,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Card sx={{ p: 5 }}>
          <Form methods={methods} onSubmit={handleSubmit}>
            <Stack spacing={3}>
              {error && (
                <Typography color="error" align="center">
                  {error}
                </Typography>
              )}

              <Field.Text name="name" label="Username" />

              <Field.Text name="password" label="Password" type="password" />

              <Button fullWidth size="large" type="submit" variant="contained" disabled={submitting} sx={{ mt: 2 }}>
                {submitting ? 'Logging in...' : 'Login'}
              </Button>
            </Stack>
          </Form>
        </Card>
      </Box>
    </Container>
  );
}
